import { SelectionFeature, mapStore } from "../store";

import { cleanTypename } from "react-migration/lib/util/cleanTypename";
import { ref } from "valtio";

export function updateDetailSelection(selection?: SelectionFeature) {
  const newSelection = selection ? ref(cleanTypename(selection)) : undefined;

  mapStore.detailSelection = newSelection;
}
